import { Property } from '@propertypal/shared/src/types/property';
import trackEvents from '@propertypal/shared/src/utils/trackEvents';
import React, { FunctionComponent, useRef } from 'react';
import Button from '../buttons/Button';
import { SubHeading } from '../typography';
import { Container, DescriptionBox, DescriptionBoxWrapper, Overlay } from './PropertyDescription.style.pn';
import PropertyRooms from './PropertyRooms';

interface Props {
  property: Property;
  onReadMore: () => void;
}

const PropertyDescription: FunctionComponent<Props> = (props) => {
  const descriptionBox = useRef<HTMLDivElement>(null);
  const roomBox = useRef<HTMLDivElement>(null);

  const onReadMoreClick = () => {
    props.onReadMore();
    trackEvents({
      eventType: 'READ_MORE',
      property: props.property.type === 'property' ? props.property.id : undefined,
      development: props.property.type === 'development' ? props.property.id : undefined,
      eventPageType: props.property.type === 'development' ? 'DEVELOPMENT_DETAILS' : 'PROPERTY_DETAILS',
    });
  };

  if (!props.property.description && !props.property.rooms?.length) {
    return null;
  }

  return (
    <Container>
      <SubHeading>Additional Information</SubHeading>

      <DescriptionBoxWrapper>
        {props.property.description && (
          <DescriptionBox
            ref={descriptionBox}
            dangerouslySetInnerHTML={{ __html: props.property.description }}
            data-testid="propertyDescription"
          />
        )}

        {!!props.property?.rooms?.length && (
          <div ref={roomBox}>
            <PropertyRooms property={props.property} />
          </div>
        )}
      </DescriptionBoxWrapper>

      <Overlay className="hide-print">
        <Button containerStyle={{ maxWidth: 200 }} onClick={onReadMoreClick} type="button" testID="readMoreButton">
          Read More
        </Button>
      </Overlay>
    </Container>
  );
};

export default PropertyDescription;
